import { useParams } from "react-router-dom";
import { LeaderboardView } from "../../components/LeaderboardView";

export const LeaderboardPage = () => {
  const { gameId } = useParams();

  if (!gameId) return null;

  return <LeaderboardView gameId={gameId} />;
};
